export default "__VITE_ASSET__Dj77Roc7__"